<template>
  <section class="landing-page-faq">
    <div class="landing-page__container">
      <h2 class="landing-page__title landing-page__title_bold landing-page-faq__title">
        {{ $t('landingPage.faq.title') }}
      </h2>
      <accordion
        :items="faqItems"
        :className="'landing-page-accordion_accordion'"
      >
      </accordion>
    </div>
  </section>
</template>

<script>
import accordion from '@/components/landing/elements/accordion';
import faqItems from '@/constants/landing/faq';

export default {
  name: 'Faq',
  components: {
    accordion,
  },
  data: () => ({
    faqItems,
  }),
};
</script>

<style scoped lang="scss">
@import "../../sass/variables";
@import "../../sass/mixins";

.landing-page-faq {
  padding-top: 122px;
  padding-bottom: 116px;
  width: 100%;
  margin: 0 auto;
  background: url("../../assets/images/landing/faq-bg.png") no-repeat;
  background-size: 100%;

  &__title {
    margin-bottom: 40px;
  }

  @include mobile {
    padding-top: 120px;
    padding-bottom: 120px;
  }

  & h2 {
    text-align: center;
  }
}

@include tablet-portrait {
  .landing-page {
    &-faq {
      padding-top: 70px;
      padding-bottom: 70px;
    }
  }
}

</style>
